export default __webpack_public_path__ + "static/media/Chestplate of the Atlantean.6cf9a654.jpg";